/* eslint no-unused-expressions: "off" */
// Disable eslint to allow this.isAuthenticated in methods

// Code by RW
// Plugin setup from https://auth0.com/blog/beginner-vuejs-tutorial-with-user-login/#Adding-Authentication-to-your-Vue-App

import Vue from 'vue'

let instance

/** Returns the current instance of the AuthenticationService */
export const getInstance = () => instance

export const useAuthenticationService = () => {
  if (instance) return instance

  instance = new Vue({
    data() {
      return {
        username: '',
        loading: true,
        isAuthenticated: false
      }
    },
    created() {
      if (this.canRefreshAccessToken()) {
        this.isAuthenticated = true
      }
    },
    computed: {
      // See Intersnack for example properties like IsAdministrator
    },
    methods: {
      getAccessToken() {
        return sessionStorage.getItem('accessToken')
      },

      canRefreshAccessToken() {
        return sessionStorage.getItem('refreshToken') !== '' && sessionStorage.getItem('refreshToken') !== null
      },

      async refreshAccessToken() {
        this.loading = true

        var objToPost = {
          refreshToken: sessionStorage.getItem('refreshToken')
        }

        var succeeded = false
        await Vue.prototype.$api.post('login/login', objToPost)
          .then((res) => {
            setAuthenticationData(res.data)
            succeeded = true
          })
          .catch(() => {
            this.logout()
            succeeded = false
          })
          .finally(() => {
            this.loading = false
          })

        return succeeded
      },

      async logout() {
        await Vue.prototype.$api.get('login/logout')

        clearAuthenticationData()
        this.username = ''
        this.isAuthenticated = false
      },

      async login(form) {
        var succesfullLogin = false
        this.loading = true

        await Vue.prototype.$api.post('login/login', form)
          .then((res) => {
            setAuthenticationData(res.data)
            this.username = form.username
            this.isAuthenticated = true

            succesfullLogin = true
          })
          .catch(() => {
            succesfullLogin = false
          })
          .finally(() => {
            this.loading = false
          })

        return succesfullLogin
      },

      /**
      * Check if user is at least in one of the provided groups
      * @param {Array} groups a list of groups, see Constants for the usergroups
      * @returns {Boolean} True or False
      */
      userIsInAGroup(groups) {
        if (Array.isArray(groups) === false) {
          return false
        }

        return groups.includes(getClaims(sessionStorage.getItem('accessToken')).usergroup)
      }
    } // methods
  }) // instance = new Vue

  // private functions
  function setAuthenticationData(data) {
    sessionStorage.setItem('accessToken', data.accessToken)
    sessionStorage.setItem('expiresAt', data.expires)
    sessionStorage.setItem('refreshToken', data.refreshToken)
  }

  function clearAuthenticationData() {
    sessionStorage.setItem('accessToken', '')
    sessionStorage.setItem('expiresAt', '')
    sessionStorage.setItem('refreshToken', '')
  }

  function getClaims(jwt) {
    // JWT's are two base64-encoded JSON objects and a trailing signature
    // joined by periods. The middle section is the data payload.
    if (jwt) {
      var jwttoken = JSON.parse(atob(jwt.split('.')[1]))
      return {
        usergroup: parseInt(jwttoken.usergroup)
      }
    }

    return {}
  }

  return instance
} // export authenticationService

// Create a simple Vue plugin to expose the wrapper object throughout the application
export const AuthenticationServicePlugin = {
  // AH: We can add an options parameter if we want, see URL on top of file
  install(Vue) {
    Vue.prototype.$authService = useAuthenticationService()
  }
}
